var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlycoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 3.33203C13.3333 4.4366 10.9455 5.33203 8 5.33203C5.05448 5.33203 2.66666 4.4366 2.66666 3.33203M13.3333 3.33203C13.3333 2.22746 10.9455 1.33203 8 1.33203C5.05448 1.33203 2.66666 2.22746 2.66666 3.33203M13.3333 3.33203V12.6654C13.3333 13.7699 10.9455 14.6654 8 14.6654C5.05448 14.6654 2.66666 13.7699 2.66666 12.6654V3.33203M13.3333 6.4431C13.3333 7.54767 10.9455 8.4431 8 8.4431C5.05448 8.4431 2.66666 7.54767 2.66666 6.4431M13.3333 9.55203C13.3333 10.6566 10.9455 11.552 8 11.552C5.05448 11.552 2.66666 10.6566 2.66666 9.55203",
    stroke: "#505050",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlycoin);
export default __webpack_public_path__ + "static/media/flycoin.b3e8eb1ad6d4dece41ce6d69841b2f4b.svg";
export { ForwardRef as ReactComponent };